import { Block, BlockProps } from "@mezo-org/mezo-clay"

export default function FullHeightContainer({
  children,
  ...props
}: BlockProps) {
  return (
    <Block width="100%" {...props}>
      {children}
    </Block>
  )
}
